import React from 'react';
import { Component } from 'react';
import { getDimensionsWithDefault } from './getDimensionsWithDefault';
import { Wrapper } from './lightCardWrappers';
import SpinnerIcon from '@atlaskit/spinner';
export class CardLoading extends Component {
  render() {
    const {
      dimensions: dimensionsProp,
      testId
    } = this.props;
    const dimensions = getDimensionsWithDefault(dimensionsProp);
    return /*#__PURE__*/React.createElement(Wrapper, {
      "data-testid": testId || 'media-card-loading',
      "data-test-loading": true,
      dimensions: dimensions
    }, /*#__PURE__*/React.createElement(SpinnerIcon, null));
  }
}